import { addCurrencyToPrice } from "src/utils/Prices";
import { AFDCategories, ERRORS_ASK_FOR_DETAILS, ErrorsVariantsAFD, NotValidQuestions } from "./AskForDetails.model";
import { CurrencyLocale } from "src/hooks/Utils/Shop/useCurrencyLocale";
import { PriceItxDto } from "src/api/customer";
import { IsEqualToPriceDTO, IsHigherToPriceDTO } from "src/utils/ParsePrice";

export const ASK_FOR_DETAIL_LEAVE_PARAM = {
  EXIT: "ASK_FOR_DETAIL_LEAVE_EXIT",
} as const;

export const onShowAFDLeaveAlertHandled = () => {
  const LEAVE_SELL_ALERT = new CustomEvent(ASK_FOR_DETAIL_LEAVE_PARAM.EXIT);
  window.dispatchEvent(LEAVE_SELL_ALERT);
};

export const addStatusToDetails = (detailsToTransform: AFDCategories[]) => {
  return (detailsToTransform || [])?.map(category => ({
    ...category,
    selected: false,
    isValid: true,
    questions: category?.questions?.map(question => ({
      ...question,
      selected: false
    }))
  }));
};

export const toggleSelection = ( categories: AFDCategories[], categoryIndex: number, questionIndex?: number
): AFDCategories[] => {
  const updatedCategories = [...categories];

  if (questionIndex !== undefined) {
    const question = updatedCategories[categoryIndex]?.questions[questionIndex];
    question.selected = !question?.selected;
  } else {
    const category = updatedCategories[categoryIndex];
    category.selected = !category?.selected;

    if (!category.selected) {
      category.questions.forEach(question => {
        question.selected = false;
      });
    }
  }

  return validateAllQuestions(updatedCategories);
};

export const selectQuestion = ( categories: AFDCategories[], categoryIndex: number, ): AFDCategories[] => {
  const updatedCategories = [...categories];
  const question = updatedCategories[categoryIndex];
  question.selected = true;
  
  return updatedCategories;
};

export const anyQuestionSelected = (categories: AFDCategories[]): boolean => {
    return categories?.some(
      (ask) => ask?.selected,
    );
};

export function filterAndRemoveSelected(categories: AFDCategories[]): { categories: AFDCategories[] } {
  const filteredCategories = categories
    .filter(category => category?.selected)
    .map(category => {
      const filteredQuestions = category?.questions?.filter(question => question?.selected).map(question => {
        const { selected, ...rest } = question;
        return rest;
      }) || [];

      const { selected, isValid, ...restCategory } = category;
      return { ...restCategory, questions: filteredQuestions };
    });

  return { categories: filteredCategories };
}

export const findInvalidQuestions = (categories: AFDCategories[], inputOfferPrice?: string): NotValidQuestions => {
  let invalidQuestionsCount = 0;
  let errorInputPrice = null;
  const updatedCategories = categories?.map(category => {
    if (category.selected && category?.questions?.length > 0) {
      const anyQuestionSelected = category?.questions?.some(
        subQuestion => subQuestion?.selected,
      );
      if (!anyQuestionSelected) {
        category.isValid = false;
        invalidQuestionsCount++;
      }
    }
    if(category?.offerInput && !inputOfferPrice && category?.selected) {
      invalidQuestionsCount++;
      errorInputPrice = ERRORS_ASK_FOR_DETAILS.REQUIRED_PRICE;
    }
    return category;
  });

  return { updatedCategories, invalidQuestionsCount, errorInputPrice };
};

export const validateAllQuestions = (categories: AFDCategories[]) => {
  const validatedCategories = categories?.map((category) => {
    if (category?.selected) {
      if (category?.questions?.length > 0) {
        const isAnySubQuestionSelected = category?.questions?.some(
          (subQuestion) => subQuestion?.selected,
        );
        if (isAnySubQuestionSelected) {
          category.isValid = true;
        }
      }
    } else {
      category.isValid = true;
    }
    return category;
  });

  return validatedCategories;
};

export const calculateFinalOfferPrice = ( price: string, currencyLocale: CurrencyLocale, ) => {
  let normalizedPrice = (price || "").replace(",", ".");
  const finalPrice = parseFloat(normalizedPrice) + 1 + (parseFloat(normalizedPrice) * 0.05);
  return addCurrencyToPrice(currencyLocale, finalPrice.toFixed(2));
};

export const validateOfferPrice = (value: string, price?: PriceItxDto, currencyLocale?: CurrencyLocale): ErrorsVariantsAFD | null => {
  if (value === "") return null;
  const normalizedValue = value.replace(/[,.\s]/g, ".");
  const numericValue = parseFloat(normalizedValue);
  if (numericValue < 1) return ERRORS_ASK_FOR_DETAILS.MINPRICE;
  if (IsHigherToPriceDTO(value, price, currencyLocale) || IsEqualToPriceDTO(value, price, currencyLocale)) return ERRORS_ASK_FOR_DETAILS.MAXPRICE;
  return null;
};